export default {
    alarmTypes: {
            AC_POWER_FAIL: "Fallo de alimentación de CA",
            AIR_IN_METER: "En el aire Medidor",
            AIR_IN_METER_SHUTOFF: "Aire en el medidor de cierre",
            ALARM_OVERFLOW: "desbordamiento de alarma",
            AVERAGE_VOLTAGE_HIGH_LIMIT: "Límite de las medias de alto voltaje",
            AVERAGE_VOLTAGE_INSIDE_RANGE: "Media Tensión dentro del rango",
            AVERAGE_VOLTAGE_LOW_LIMIT: "Tensión límite bajo promedio",
            AVERAGE_VOLTAGE_OUTSIDE_RANGE: "Tensión media fuera del rango",
            BACKUP_BATTERY_LOW_VOLTAGE: "Respaldo de batería de bajo voltaje",
            BATTERY: "Batería baja",
            BATTERY_CONSUMPTION_INSIDE_RANGE: "El consumo de la batería dentro del rango",
            BATTERY_CONSUMPTION_OUTSIDE_RANGE: "El consumo de la batería fuera del rango",
            BATTERY_DOOR_TAMPER: "Batería Puerta de sabotaje",
            BATTERY_LOW_VOLTAGE: "Batería Baja Tensión",
            BATTERY_REMAINING_15_PERCENT: "15% de batería restante",
            BATTERY_REMAINING_25_PERCENT: "25% de batería restante",
            BATTERY_REMAINING_5_PERCENT: "5% de batería restante",
            BEYOND_END_OF_LIFE: "Más allá de final de la vida",
            BG_ALGAE_CHANGE_RATE_OVER_LIMIT: "BG algas velocidad de cambio de límite por arriba",
            BG_ALGAE_CHANGE_RATE_UNDER_LIMIT: "BG algas Límite de Cambio En Velocidad",
            BG_ALGAE_INSIDE_RANGE: "BG algas dentro del rango",
            BG_ALGAE_OUTSIDE_RANGE: "BG algas Fuera del Rango",
            BIDIRECTIONAL_COMMUNICATION_FAILED: "Falló la comunicación bidireccional",
            BLOCK_CRC_FAILED: "Bloque CRC Error",
            BLOCKED_RELAY: "bloqueado Relay",
            BOARD_FAILURE: "fallo en la placa",
            BROWN_OUT: "Brown falló",
            BROWNOUT_DETECTED: "Brownout detectado",
            CALIBRATION_LOST: "Calibración perdido",
            CASING_HIGH_VOLTAGE: "Carcasa de alto voltaje",
            CASING_LOW_VOLTAGE: "Carcasa de Baja Tensión",
            CASING_VOLTAGE_INSIDE_RANGE: "Carcasa de voltaje dentro del rango",
            CASING_VOLTAGE_OUTSIDE_RANGE: "La carcasa de tensión fuera del rango",
            CHLOROPHYLL_CHANGE_RATE_OVER_LIMIT: "La clorofila velocidad de cambio de límite por arriba",
            CHLOROPHYLL_CHANGE_RATE_UNDER_LIMIT: "La clorofila Límite de Cambio En Velocidad",
            CHLOROPHYLL_INSIDE_RANGE: "La clorofila dentro del rango",
            CHLOROPHYLL_OUTSIDE_RANGE: "La clorofila fuera del rango",
            CLOCK_ERROR: "Error de reloj",
            COMMUNICATIONS_FAILURE_SENSOR: "La falta de comunicación del sensor",
            COMMUNICATIONS_WARNING: "Advertencia comunicaciones",
            COMPENSATION_FAILURE: "La falta de compensación",
            CONDUCTIVITY_CHANGE_RATE_OVER_LIMIT: "Conductividad velocidad de cambio de límite por arriba",
            CONDUCTIVITY_CHANGE_RATE_UNDER_LIMIT: "Límite de Cambio de conductividad En Velocidad",
            CONDUCTIVITY_INSIDE_RANGE: "Dentro de conductividad Rango",
            CONDUCTIVITY_OUTSIDE_RANGE: "Conductividad fuera del rango",
            CONFIGURATION_ERROR: "Error de configuración",
            CONFIGURATION_ERROR_DEMAND_OR_TOU: "Error de configuración (o demanda CDU)",
            CONFIGURATION_LOST: "configuración de Lost",
            CORRECTOR_ALARM: "alarma corrector",
            CORRUPT_BLOCK: "Bloquear corrupta",
            COUNTER_OVERFLOW: "contador de desbordamiento",
            COUPON_HIGH_VOLTAGE: "Cupón de alto voltaje",
            COUPON_LOW_VOLTAGE: "Cupón de bajo voltaje",
            COUPON_VOLTAGE_INSIDE_RANGE: "Cupón de voltaje dentro del rango",
            COUPON_VOLTAGE_OUTSIDE_RANGE: "Cupón de tensión fuera del rango",
            CRITICAL_HARDWARE_WARNING: "Advertencia importante de hardware",
            CRITICAL_READ_TIME_DRIFT: "Tiempo de lectura crítica Drift",
            CUSTOMER_LEAK: "fugas cliente",
            CUT_WIRE: "corte de alambre",
            CUT_WIRE_35_DAY: "Día corte de alambre 35",
            CYCLING_LAMP: "bicicleta de la lámpara",
            DALI_DRIVER_FAILURE: "El fracaso del controlador DALI",
            DAYLIGHT_BURNER: "quemador de la luz del día",
            DC_CURRENT_INSIDE_RANGE: "DC actual dentro del rango",
            DC_CURRENT_OUTSIDE_RANGE: "Fuera del Rango de corriente dc",
            DC_DETECTED_IN_CIRCUIT: "Dc detectado en el circuito de",
            DC_VOLTAGE_INSIDE_RANGE: "Dentro del voltaje de CC Rango",
            DC_VOLTAGE_OUTSIDE_RANGE: "CC Rango de voltaje exterior",
            DEAD_BATTERY: "Bateria muerta",
            DEMAND_OVERLOAD: "sobrecarga de la demanda",
            DEVICE_RESET: "Reiniciar dispositivo",
            DEVICE_SYSTEM_ERROR: "Dispositivo de sistema de Error",
            DIGITAL_INPUT_A: "Una entrada digital",
            DIGITAL_INPUT_A_ALARM_GAS: "Entrada Digital Gas Una alarma",
            DIGITAL_INPUT_A_ALARM_GAS_LATCHED: "Entrada digital una alarma de gas trabó",
            DIGITAL_INPUT_A_ALARM_SMARTPOINT_LATCHED: "Entrada digital Una alarma SmartPoint trabó",
            DIGITAL_INPUT_A_ALARM_WATER: "Una entrada digital Alarma de agua",
            DIGITAL_INPUT_A_ALARM_WATER_LATCHED: "Entrada digital Una Alarma de agua retenidos",
            DIGITAL_INPUT_B: "Entrada Digital B",
            DIGITAL_INPUT_B_ALARM__GAS_LATCHED: "Entrada Digital B Indicadores de gas trabó",
            DIGITAL_INPUT_B_ALARM__WATER_LATCHED: "Entrada Digital B Alarma de agua retenidos",
            DIGITAL_INPUT_B_ALARM_GAS: "Entrada Digital Gas B Alarma",
            DIGITAL_INPUT_B_ALARM_GAS_LATCHED: "Entrada Digital B Indicadores de gas trabó",
            DIGITAL_INPUT_B_ALARM_SMARTPOINT_LATCHED: "Entrada Digital B Alarma SmartPoint trabó",
            DIGITAL_INPUT_B_ALARM_WATER: "Entrada Digital B Alarma de agua",
            DISCONNECT_LOAD_SIDE_VOLTAGE_SENSE: "Desconexión de la carga lateral Sensor de Voltaje",
            DISCONNECT_OPEN_INDICATOR: "Indicador de desconexión abierto",
            DISSOLVED_OXYGEN_CHANGE_RATE_OVER_LIMIT: "El oxígeno disuelto velocidad de cambio de límite por arriba",
            DISSOLVED_OXYGEN_CHANGE_RATE_UNDER_LIMIT: "El oxígeno disuelto Límite de Cambio En Velocidad",
            DISSOLVED_OXYGEN_INSIDE_RANGE: "El oxígeno disuelto dentro del rango",
            DISSOLVED_OXYGEN_OUTSIDE_RANGE: "El oxígeno disuelto fuera del rango",
            DOOR_OPEN: "Puerta abierta",
            DOWNLINK: "Comandos de enlace descendente",
            DOWNLINK_COMMANDS: "Comandos de enlace descendente",
            DUPLICATE_BUDDY_COUNT: "Amigos duplicados",
            ECU_FAULT: "Ambiental",
            EEPROM_FAILURE_NO_READABLE_BLOCKS: "EEPROM Fallo -No lectura mecánica Bloques",
            EEPROM_HAN_WRITE_TIMEOUT: "Tiempo de espera de escritura de EEPROM / HAN",
            EEPROM_READ_ERROR: "EEPROM Error de lectura",
            EEPROM_READ_RETRY: "Leer EEPROM reintento",
            EMF_RANGE: "Rango EMF",
            EMPTY_PIPE: "tubería vacía",
            ENCRYPTION_FAILED: "No se ha podido cifrado",
            ENDPOINT_DATA: "Datos de punto final",
            ENDPOINT_EVENT: "Evento de punto final",
            EPROM_WEAR: "Desgaste EPROM",
            EXCESS_FLOW: "exceso de Flujo",
            EXCESS_FLOW_SHUTOFF: "El exceso el cierre del flujo",
            FACTORY_ERROR: "Error de fábrica",
            FAILED_TO_COMPLETE_METER_FIRMWARE_UPGRADE: "No se pudo completar la actualización del firmware del medidor",
            FAILED_TO_START_METER_FIRMWARE_UPGRADE: "Error de actualización de firmware para comenzar Meter",
            FIXTURE_TYPE_CHANGED: "Tipo de Aparato Cambiado",
            FLOW_INSIDE_RANGE: "Dentro de la gama de flujo",
            FLOW_OUTSIDE_RANGE: "Fuera del Rango de flujo",
            FORWARD_POWER: "Poder delantero",
            FREE_CHLORINE_CHANGE_RATE_OVER_LIMIT: "Cloro Libre velocidad de cambio de límite por arriba",
            FREE_CHLORINE_CHANGE_RATE_UNDER_LIMIT: "Cloro Libre Cambio Límite Bajo Tasa",
            FREE_CHLORINE_INSIDE_RANGE: "Dentro de Cloro Libre Rango",
            FREE_CHLORINE_OUTSIDE_RANGE: "El cloro libre fuera del rango",
            FUSE_FAILURE: "Falla de fusible",
            GLIDE_SLOPE: "Pendiente de planeo",
            GPS: "GPS Error",
            GPS_HARDWARE_FAILURE: "La falta de hardware GPS",
            GPS_LOCATION_CHANGED: "Localización GPS Changed",
            GPS_POSITION: "Posición GPS",
            GPT: "GPT",
            HARD_EEPROM_ERROR: "DURO EEPROM Error",
            HARD_KWH_ERROR: "Duro Kwh error",
            HARDWARE_ALERTS_PAUSED: "Alertas de hardware En pausa",
            HARDWARE_FAILURE: "Fallo de hardware",
            HARDWARE_FAULT: "Fallo de hardware",
            HIGH_BG_ALGAE: "BG alta Algas",
            HIGH_CHLOROPHYLL: "La clorofila alta",
            HIGH_COIL_CURRENT: "Alta Corriente de la bobina",
            HIGH_COIL_VOLTAGE: "Alto Voltaje de la bobina",
            HIGH_CONDUCTIVITY: "alta conductividad",
            HIGH_CURRENT: "Alta corriente",
            HIGH_DC_CURRENT: "Alta de corriente dc",
            HIGH_DC_VOLTAGE: "De alto voltaje DC",
            HIGH_DISSOLVED_OXYGEN: "Oxígeno Disuelto alta",
            HIGH_FLOW: "Alto flujo",
            HIGH_FREE_CHLORINE: "Alta Cloro Libre",
            HIGH_HYDROGEN_SULFIDE: "Alto Sulfuro de Hidrógeno",
            HIGH_LEVEL: "Nivel alto",
            HIGH_ODORANT_CONCENTRATION: "La alta concentración de odorante",
            HIGH_PH: "pH alto",
            HIGH_POWER: "Alto Voltaje",
            HIGH_PRESSURE: "Alta presión",
            HIGH_PRESSURE_SHUTOFF: "De alta presión de cierre",
            HIGH_PRESSURE_WARNING: "Advertencia de Alta Presión",
            HIGH_TEMPERATURE: "Alta temperatura",
            HIGH_TEMPERATURE_DETECTED: "Alta temperatura detectada",
            HIGH_TEMPERATURE_SHUTOFF: "Alta temperatura de interrupción",
            HIGH_TOTAL_CHLORINE: "Alta Cloro Total",
            HIGH_TURBIDITY: "alta turbidez",
            HIGH_WEIGHT: "alto Peso",
            HISTORY_OVERFLOW: "historia de desbordamiento",
            HISTORY_OVERFLOW_GAS: "Historia de desbordamiento de gas",
            HYDROGEN_SULFIDE_CHANGE_RATE_OVER_LIMIT: "El sulfuro de hidrógeno para cambiar la velocidad límite por arriba",
            HYDROGEN_SULFIDE_CHANGE_RATE_UNDER_LIMIT: "El sulfuro de hidrógeno Límite de Cambio En Velocidad",
            HYDROGEN_SULFIDE_INSIDE_RANGE: "Sulfuro de hidrógeno dentro del rango",
            HYDROGEN_SULFIDE_OUTSIDE_RANGE: "El sulfuro de hidrógeno Fuera del Rango",
            IDLE: "Ocioso",
            IDLE_NOISE: "Ruido Inactivo",
            INDEX_LOST: "Índice de Lost",
            INTERNAL_COMMUNICATION_ERROR: "Error de comunicación interna",
            INTERNAL_FIRMWARE_ERROR_200: "Error interno del firmware -200",
            INTERNAL_FIRMWARE_ERROR_400: "Error interno del firmware -400",
            JT_MODULE: "JT_MODULE",
            LAMP_FAILURE: "El fracaso de la lámpara",
            LAST_HEARD: "Último oído",
            LAST_HEARD_ON_AIR: "Último escuchado (en el aire)",
            LAST_COUNTER_MESSAGE: "Último mensaje de contador",
            LAST_TRANSMIT_REPORT: "Informe de última transmisión",
            LAST_UPLINK_MESSAGE_RECEIVED: "Último mensaje de enlace ascendente recibido",
            LEVEL_INSIDE_RANGE: "Rango de nivel interior",
            LEVEL_OUTSIDE_RANGE: "Nivel fuera del rango",
            LOW_BATTERY_GAS: "Gas de batería baja",
            LOW_BATTERY_SMARTPOINT_LATCHED: "Smartpoint baja de pilas cerrada",
            LOW_BATTERY_VOLTAGE: "Tensión de batería baja",
            LOW_BATTERY_VOLTAGE_ELECTRIC: "Batería Baja Tensión eléctrica",
            LOW_BG_ALGAE: "Las algas bajo BG",
            LOW_CHLOROPHYLL: "La clorofila baja",
            LOW_COIL_CURRENT: "Bajo Corriente de la bobina",
            LOW_COIL_VOLTAGE: "Voltaje de la bobina de baja",
            LOW_CONDUCTIVITY: "baja conductividad",
            LOW_CURRENT: "Corriente baja",
            LOW_DC_CURRENT: "Bajo Corriente DC",
            LOW_DC_VOLTAGE: "Baja Tensión DC",
            LOW_DISSOLVED_OXYGEN: "Oxígeno Disuelto baja",
            LOW_FIELD: "Campo bajo",
            LOW_FLOW: "Flujo bajo",
            LOW_FREE_CHLORINE: "Bajo Cloro Libre",
            LOW_HYDROGEN_SULFIDE: "Bajo Sulfuro de Hidrógeno",
            LOW_LEVEL: "Nivel bajo",
            LOW_LOSS_POTENTIAL: "Potencial de pequeñas pérdidas",
            LOW_METROLOGY_BATTERY_VOLTS: "Bajo Metrología voltios de la batería",
            LOW_ODORANT_CONCENTRATION: "Concentración baja odorante",
            LOW_PH: "El pH bajo",
            LOW_POWER: "baja Potencia",
            LOW_POWER_FACTOR: "Factor de potencia de baja",
            LOW_PRESSURE: "Baja presión",
            LOW_PRESSURE_SHUTOFF: "Baja presión de cierre",
            LOW_PRESSURE_WARNING: "Bajo advertencia de presión",
            LOW_SMARTPOINT_BATTERY_VOLTS: "Bajo SmartPoint voltios de la batería",
            LOW_TEMPERATURE: "Baja temperatura",
            LOW_TOTAL_CHLORINE: "Bajo Cloro Total",
            LOW_TURBIDITY: "baja turbidez",
            LOW_VALVE_BATTERY_VOLTS: "Válvula de baja voltios de la batería",
            LOW_WEIGHT: "Bajo peso",
            MAGNETIC: "Magnético",
            MAGNETIC_TAMPER: "Tamper magnética",
            MAGNETIC_TAMPER_35_DAY: "Magnética Día 35 de sabotaje",
            MAXIMUM_VOLTAGE_HIGH_LIMIT: "Límite Máximo de alto voltaje",
            MAXIMUM_VOLTAGE_INSIDE_RANGE: "Tensión máxima dentro del rango",
            MAXIMUM_VOLTAGE_LOW_LIMIT: "Tensión límite máximo de baja",
            MAXIMUM_VOLTAGE_OUTSIDE_RANGE: "Tensión máxima fuera del rango",
            MEASUREMENT_ERROR: "Error de medición",
            MEMORY_BLOCK_CRC_RETRY: "Bloque de memoria CRC reintento",
            MEMORY_BLOCK_WRITE_ERROR: "Bloque de memoria Error de escritura",
            MEMORY_ERROR: "Error de memoria",
            MEMORY_FULL: "Memoria llena",
            MEMORY_WARNING: "Advertencia de memoria",
            MEMORY_WRITE_ERROR: "Error de escritura de la memoria",
            MEMORY_WRITE_FAILURE_NO_FREE_BLOCKS: "Escribir de memoria Fracaso - No hay bloques libres",
            META_DATA_WARNING: "Advertencia de Meta Data",
            METER_CHANGED_WARNING: "Meter Advertencia Changed",
            METER_COMMS_INTERFACE_ERRORS: "Los errores del medidor de interfaz de comunicaciones",
            METER_COMMUNICATION_FAILED: "Medidor de Comunicación Error",
            METER_COMMUNICATION_FAILURE: "El fracaso medidor de Comunicación",
            METER_DISCONNECT_TAMPER: "Meter Desconectar Tamper",
            METER_HW_FAILURE: "El fracaso metros HW",
            METER_MALFUNCTION_35_DAY_GAS: "Mal funcionamiento del medidor de gas 35 Día",
            METER_POWER_RESET: "Restablecimiento del medidor de energía",
            METER_PROCESSOR_FAILED: "Procesador Meter Failed",
            METER_READ_FAILURE: "La falta de lectura del contador",
            METER_REBOOT: "Medidor de reinicio",
            METER_REGISTER_ERROR: "Error del registro del metro",
            METER_UNPROGRAMMED: "Medidor no programada",
            METROLOGY_A_PHASE_DISTORTION: "Metrología Una fase de la distorsión",
            METROLOGY_B_PHASE_DISTORTION: "Metrología B Fase Distorsión",
            METROLOGY_BAD_PASSWORD: "Metrología contraseña incorrecta",
            METROLOGY_BAD_REGISTER_NUM: "Metrología Malo Registro Num",
            METROLOGY_BATTERY_AND_POTENTIAL_FAILURE: "Metrología de la batería y falla potencial",
            METROLOGY_C_PHASE_DISTORTION: "Metrología C Fase Distorsión",
            METROLOGY_CALIBRATION_ERROR: "Error de calibración de metrología",
            METROLOGY_CHECKSUM_ERROR: "Metrología suma de comprobación de errores",
            METROLOGY_CLOCK_ERROR: "Error Metrología Reloj",
            METROLOGY_CODE_ERROR: "Código de error de metrología",
            METROLOGY_CONFIGURATION_ERROR: "Error de configuración de metrología",
            METROLOGY_COVER_DETECT: "Metrología cubierta Detect",
            METROLOGY_CROSS_PHASE_RECEIVED_KWH: "Fase Cruz Metrología KWH Recibido",
            METROLOGY_DATA_ERROR: "Error de datos de metrología",
            METROLOGY_DC_DETECT: "Metrología CC Detect",
            METROLOGY_DEMAND_OVERLOAD: "Exigir la metrología de sobrecarga",
            METROLOGY_DSP_ERROR: "Metrología DSP Error",
            METROLOGY_EEPROM_ERROR: "Metrología EEPROM Error",
            METROLOGY_EEPROM_READ_ERROR: "Metrología EEPROM Error de lectura",
            METROLOGY_FAILURE: "La falta de metrología",
            METROLOGY_FW_UPDATE_FAILED: "Metrología FW Error de actualización",
            METROLOGY_HARD_EEPROM_ERROR: "Metrología DURO EEPROM Error",
            METROLOGY_HIGH_DISTORTION: "Metrología de alta distorsión",
            METROLOGY_HIGH_LINE_CURRENT: "Metrología alta línea actual",
            METROLOGY_HIGH_TEMP: "Metrología de alta temperatura",
            METROLOGY_HW_FAILURE: "La falta de metrología HW",
            METROLOGY_INACTIVE_PHASE_CURRENT: "Metrología Inactivo fase actual",
            METROLOGY_INTEGRITY_CHECK: "Comprobación de integridad de la metrología",
            METROLOGY_INVERSION_TAMPER: "Metrología Inversion Tamper",
            METROLOGY_LEADING_KVARH: "Metrología kVARh líder",
            METROLOGY_LOSS_OF_PROGRAM: "La pérdida de la metrología Programa",
            METROLOGY_LOW_BATTERY: "Metrología de batería baja",
            METROLOGY_LOW_BATTERY_SENSOR: "Metrología sensor de batería baja",
            METROLOGY_LOW_LOSS_POTENTIAL: "Bajo Potencial de la metrología Pérdida",
            METROLOGY_MEASUREMENT_ERROR: "Error de medición Metrología",
            METROLOGY_MEMORY_WRITE_ERROR: "Memoria de metrología Error de escritura",
            METROLOGY_METER_CHIP_ERROR: "Metrología medidor de astillas Error",
            METROLOGY_METER_UNPROGRAMMED: "Metrología Meter no programada",
            METROLOGY_METERING_ERROR: "Metrología Metering Error",
            METROLOGY_NON_VOLATILE_MEMORY_ERROR: "Metrología para no error de memoria volátil",
            METROLOGY_OVER_VOLTAGE: "Metrología de sobrevoltaje",
            METROLOGY_OVER_VOLTAGE_PHASE_A: "Metrología Sobre el voltaje Fase A",
            METROLOGY_OVER_VOLTAGE_PHASE_B: "Metrología Sobre el voltaje Fase B",
            METROLOGY_OVER_VOLTAGE_PHASE_C: "Metrología Sobre el voltaje de fase C",
            METROLOGY_PHASE_DIFFERENCE: "Diferencia de fase de metrología",
            METROLOGY_PROCESSOR_FAILED: "Procesador de metrología Falló",
            METROLOGY_RAM_ERROR: "Metrología Error de RAM",
            METROLOGY_RAM_TEST_FAIL: "Metrología RAM reprobación de prueba",
            METROLOGY_RECEIVED_KWH: "Metrología KWH recibidos",
            METROLOGY_REGISTER_CHECK_ERROR: "Metrología registro de cheques de error",
            METROLOGY_RESET: "Restablecer la metrología",
            METROLOGY_ROM_ERROR: "Metrología ROM Error",
            METROLOGY_ROM_TEST_FAIL: "Metrología ROM reprobación de prueba",
            METROLOGY_SAMPLE_MISSING: "Metrología Muestra Missing",
            METROLOGY_SOFT_EEPROM_ERROR: "Metrología SUAVE EEPROM Error",
            METROLOGY_SWITCH_AUTO_CORRECTION_INITIATED: "Interruptor de metrología auto-corrección Iniciado",
            METROLOGY_SWITCH_IN_WRONG_STATE: "Interruptor de metrología En el estado incorrecto",
            METROLOGY_SYSTEM_ERROR: "Error del sistema de metrología",
            METROLOGY_TAMPER: "metrología de sabotaje",
            METROLOGY_TIME_ADJUSTED: "Metrología de tiempo ajustado",
            METROLOGY_UNAVAILABLE: "metrología No Disponible",
            METROLOGY_UNDER_VOLTAGE: "Metrología Bajo Voltaje",
            METROLOGY_UNDER_VOLTAGE_PHASE_A: "Metrología Bajo Voltaje Fase A",
            METROLOGY_UNDER_VOLTAGE_PHASE_B: "Metrología Bajo Voltaje Fase B",
            METROLOGY_UNDER_VOLTAGE_PHASE_C: "Metrología Bajo Voltaje Fase C",
            METROLOGY_VOLTAGE_REFERENCE_ERROR: "Error Metrología Referencia de tensión",
            METROLOGY_VOLTAGE_UNBALANCE: "Desequilibrio de tensión Metrología",
            METROLOGY_WATCHDOG_TIMEOUT: "Metrología Watchdog Timeout",
            METROLOGY_WRITE_FAILED: "Metrología Write Error",
            MINIMUM_VOLTAGE_HIGH_LIMIT: "Límite mínimo de alto voltaje",
            MINIMUM_VOLTAGE_INSIDE_RANGE: "Tensión mínima dentro del rango",
            MINIMUM_VOLTAGE_LOW_LIMIT: "Tensión límite bajo mínimos",
            MINIMUM_VOLTAGE_OUTSIDE_RANGE: "Tensión mínima Fuera del Rango",
            MPT_MESSAGE_COUNT: "Mensajes MPT",
            NATIVE_COUPON_HIGH_VOLTAGE: "Cupón nativa de alto voltaje",
            NATIVE_COUPON_LOW_VOLTAGE: "Cupón nativa de Baja Tensión",
            NATIVE_COUPON_VOLTAGE_INSIDE_RANGE: "Cupón nativa de voltaje dentro del rango",
            NATIVE_COUPON_VOLTAGE_OUTSIDE_RANGE: "Tensión Cupón nativa fuera del rango",
            NEAR_END_OF_LIFE: "Cerca final de la vida",
            NON_STANDARD_OPERATION: "la operación no estándar",
            NON_VOLATILE_MEMORY_ERROR: "Sin error de memoria volátil",
            NTP: "NTP Error",
            NTP_ERROR: "NTP Error",
            NTP_DRIFTING: "La desviación de NTP excede la tolerancia permitida",
            NTP_MISSING: "NTP no responde",
            ODORANT_CONCENTRATION_INSIDE_RANGE: "Concentración odorante Dentro de la gama",
            ODORANT_CONCENTRATION_OUTSIDE_RANGE: "Concentración odorante fuera del rango",
            OPEN_CIRCUIT: "Circuito abierto",
            OPERATIONAL_ALERTS_PAUSED: "En pausa operativa Alertas",
            OPTICAL_PORT_COMMUNICATION_FAILURE: "El fracaso Puerto de comunicación óptica",
            OPTICAL_PORT_LOCKOUT: "Puerto óptico de bloqueo",
            OTHER_SENSOR_CHANGE_RATE_OVER_LIMIT: "Otros Cambiar sensor de frecuencia límite por arriba",
            OTHER_SENSOR_CHANGE_RATE_UNDER_LIMIT: "Otros Cambiar sensor de límite bajo una velocidad",
            OTHER_SENSOR_HIGH_MEASUREMENT: "Otro alta medición Sensor",
            OTHER_SENSOR_INSIDE_RANGE: "Otro Dentro del alcance del sensor",
            OTHER_SENSOR_LOW_MEASUREMENT: "Otro sensor de baja Medición",
            OTHER_SENSOR_OUTSIDE_RANGE: "Otro sensor fuera del rango",
            OVER_CURRENT: "Con el actual",
            OVER_TEMPERATURE: "Exceso de temperatura",
            OVER_VOLTAGE: "sobre voltaje",
            OVERCURRENT: "sobrecorriente",
            PARTIAL_DATA_MISMATCH: "No coinciden los datos parciales",
            PERMANENT_ERROR: "Error permanente",
            PH_CHANGE_RATE_OVER_LIMIT: "pH velocidad de cambio de límite por arriba",
            PH_CHANGE_RATE_UNDER_LIMIT: "Límite de Cambio En Velocidad de pH",
            PH_INSIDE_RANGE: "Dentro de la gama de pH",
            PH_OUTSIDE_RANGE: "pH fuera del rango",
            PHYSICAL_TAMPER: "Tamper física",
            PIPE_HIGH_VOLTAGE: "Tubo de alto voltaje",
            PIPE_LOW_VOLTAGE: "Tubería de baja tensión",
            PIPE_VOLTAGE_INSIDE_RANGE: "Tubería de tensión dentro del rango",
            PIPE_VOLTAGE_OUTSIDE_RANGE: "Rango de voltaje de tubo exterior",
            POST_INSTALLATION_ALARM_CONFIG_AUDIT: "Alarma posterior a la instalación de configuración de auditoría",
            POST_INSTALLATION_COMMS_AUDIT: "Posterior a la instalación de comunicaciones de Auditoría",
            POST_INSTALLATION_LOCATION_AUDIT: "Posterior a la instalación Ubicación de Auditoría",
            POST_INSTALLATION_SENSOR_AUDIT: "Posterior a la instalación del sensor de Auditoría",
            POST_INSTALLATION_SMARTPOINT_CONFIG_AUDIT: "Posterior a la instalación Smartpoint Config Auditoría",
            POWER_FAIL: "Falla de energía",
            POWER_FAIL_BIT_SET: "conjunto de bits de fallo de alimentación",
            POWER_FAILURE: "Fallo de alimentación",
            POWER_OUT: "Sin electricidad",
            POWER_RESTORE: "Restitución de Energía",
            POWER_RESTORE_BIT_SET: "Restaurar el poder conjunto de bits",
            POWER_SURGE: "Sobrecarga de energía",
            PPS: "PPS Error",
            PRE_INSTALLATION_ALARM_CONFIG_AUDIT: "Preinstalación de alarma de configuración de auditoría",
            PRE_INSTALLATION_COMMS_AUDIT: "Pre-instalación de comunicaciones de Auditoría",
            PRE_INSTALLATION_LOCATION_AUDIT: "Pre-Instalación Localización de Auditoría",
            PRE_INSTALLATION_SENSOR_AUDIT: "Previa a la instalación del sensor de Auditoría",
            PRE_INSTALLATION_SMARTPOINT_AUDIT: "Pre-instalación de Auditoría Smartpoint",
            PRESSURE_ALERTS_PAUSED: "Presión Alertas pausa",
            PRESSURE_COMPENSATION_FAILURE: "La falta de presión de Compensación",
            PRESSURE_INSIDE_RANGE: "La presión dentro del rango",
            PRESSURE_OUTSIDE_RANGE: "La presión fuera del rango",
            PROCESSOR_LOW_VOLTAGE: "Procesador de bajo voltaje",
            RADIO_COMMUNICATION_FAILED: "Comunicación por radio Falló",
            RAM_FAILED: "Error de RAM",
            RAM_TEST_FAIL: "RAM reprobación de prueba",
            RAPID_TEMP_RISE_SHUTOFF: "Temperatura de cierre rápido aumento",
            READ_DATA_QUARANTINE: "Leer datos de cuarentena",
            READ_FAILURE: "Fallo de lectura",
            RECTIFIER_POWER: "Rectificador de potencia",
            REFLECTED_POWER: "Poder reflejado",
            REGISTER_CHECK_ERROR: "Error de comprobación de Registro",
            REGISTER_ERROR: "Registro de errores",
            REGISTER_OVER_TEMPERATURE: "Registro de temperatura excesiva",
            RELAY_CORRECTED: "retransmitir corregido",
            REMOTE_DISCONNECT_SWITCH_STATE_CHANGED: "Interruptor de desconexión remota Estado Changed",
            RESET_ERROR: "reposición de error",
            REVERSE_ENERGY: "Energía inversa",
            REVERSE_FLOW: "Flujo inverso",
            REVERSE_FLOW_GAS: "Flujo de Gas inversa",
            REVERSE_FLOW_GAS_SMARTPOINT_LATCHED: "Inversa de flujo de gas SmartPoint trabado",
            REVERSE_FLOW_SHUTOFF: "Flujo inverso de cierre",
            ROM_FAILED: "No se ha podido ROM",
            ROM_TEST_FAIL: "ROM reprobación de prueba",
            SEISMIC_EVENT: "evento sísmico",
            SELF_DISCOVERY_FAILURE: "La falta de auto-descubrimiento",
            SENSOR_READ_FAILURE: "Sensor Fallo de lectura",
            SENSOR_READING_FAILED: "Sensor - Lectura Error",
            SERVICE_LIMITING_CLOSE: "Servicio Cerrar Limitación",
            SERVICE_LIMITING_OPEN_DUE_TO_HIGH_CURRENT: "La limitación de servicio abierto debido a la alta corriente",
            SERVICE_LIMITING_OPEN_DUE_TO_HIGH_DEMAND: "La limitación de servicio abierta debido a la alta demanda",
            SINGLE_PHASE_B_FAIL: "Monofásico B Falla",
            SINGLE_PHASE_C_FAIL: "Monofásico C Falla",
            SINGLE_PHASE_FAIL: "Monofásico Falla",
            SOFT_EEPROM_ERROR: "SUAVE EEPROM Error",
            SOFT_KWH_ERROR: "Soft Kwh error",
            STALE_REPORT_DOWNLINK_UNAVAILABLE: "Estación base fuera de línea debido a que el informe de enlace descendente no está disponible",
            SWAPPED_METER: "intercambiadas Meter",
            SWITCH_AUTO_CORRECTION_INITIATED: "Cambio automático de corrección Iniciado",
            SWITCH_CHATTER_DETECTED: "Chasquido del interruptor detecta",
            SWITCH_IN_WRONG_STATE: "Interruptor en estado incorrecto",
            TAMPER: "Manosear",
            TAMPER_CURRENT: "tamper actual",
            TAMPER_LCM_VOLTAGE: "Tamper LCM Voltaje",
            TAMPER_LOAD_VOLTAGE_ON_RELAY_1: "Tamper de carga de tensión en el relé 1",
            TAMPER_LOAD_VOLTAGE_ON_RELAY_2: "Tamper de carga de tensión en el relé 2",
            TAMPER_LOAD_VOLTAGE_ON_RELAY_3: "Tamper de carga de tensión en el relé 3",
            TAMPER_MEASURED_CURRENT_ON_RELAY_1: "Tamper corriente medida en Relay 1",
            TAMPER_MEASURED_CURRENT_ON_RELAY_2: "Tamper corriente medida en Relay 2",
            TAMPER_MEASURED_CURRENT_ON_RELAY_3: "Tamper corriente medida en Relay 3",
            TAMPER_VOLTAGE: "Tensión de manipulaciones",
            TEMPERATURE_ALERTS_PAUSED: "Temperatura Alertas pausa",
            TEMPERATURE_COMPENSATION_FAILURE: "La falta de compensación de temperatura",
            TEMPERATURE_INSIDE_RANGE: "Dentro de la gama de temperatura",
            TEMPERATURE_OUTSIDE_RANGE: "Temperatura fuera del rango",
            TEMPORARY_ERROR: "Error temporal",
            TILT_TAMPER: "inclinación de sabotaje",
            TIME_ADJUSTED: "tiempo ajustado",
            TIME_STRAY_DOWNLINK_UNAVAILABLE: "Estación base fuera de línea debido a una desviación horaria",
            TOTAL_CHLORINE_CHANGE_RATE_OVER_LIMIT: "Cloro Total velocidad de cambio de límite por arriba",
            TOTAL_CHLORINE_CHANGE_RATE_UNDER_LIMIT: "Cloro Total Límite de Cambio En Velocidad",
            TOTAL_CHLORINE_INSIDE_RANGE: "Dentro de la gama total de cloro",
            TOTAL_CHLORINE_OUTSIDE_RANGE: "Cloro Total fuera del rango",
            TOUCH_READ_FAILURE: "Toque Fallo de lectura",
            TURBIDITY_CHANGE_RATE_OVER_LIMIT: "Turbidez velocidad de cambio de límite por arriba",
            TURBIDITY_CHANGE_RATE_UNDER_LIMIT: "Límite de Cambio de turbidez En Velocidad",
            TURBIDITY_INSIDE_RANGE: "Turbidez dentro del rango",
            TURBIDITY_OUTSIDE_RANGE: "Turbidez fuera del rango",
            UNCHANGED_LIGHT_LEVEL: "Sin cambios de nivel de luz",
            UNDER_TEMPERATURE: "Bajo temperatura",
            UNIQUE_BUDDY_COUNT: "Amigos únicos",
            UNKNOWN_GAS: "desconocido Gas",
            UNSATISFACTORY_READING: "lectura insatisfactoria",
            UNSTABLE_POWER: "Poder inestable",
            UPGRADE_MODE: "el modo de actualización",
            UPLINK_MESSAGES: "Mensajes de enlace ascendente",
            UPLINK_TRAFFIC_DROP: "Caída del tráfico de enlace ascendente",
            VALVE_CLOSED: "válvula cerrada",
            VALVE_CLOSED_AUTOMATICALLY: "Válvula cerrada automáticamente",
            VALVE_IN_TRANSITION: "Válvula en Transición",
            VALVE_OPENED: "válvula abierta",
            VALVE_OPENED_AUTOMATICALLY: "La válvula abre automáticamente",
            VALVE_POSITION_UNKNOWN: "Posición de la válvula Desconocido",
            VALVE_REDUCED_FLOW: "La reducción del flujo de la válvula",
            VALVE_REDUCED_FLOW_AUTOMATICALLY: "La reducción del flujo de la válvula automáticamente",
            VALVE_STATE_CHANGED: "Estado de la válvula Changed",
            VALVE_STATE_TEMPORARILY_UNKNOWN_AFTER_REBOOT: "Estado de la válvula desconocido temporalmente después de reiniciar",
            VALVE_TRANSITION_FAILURE: "El fracaso de la válvula de Transición",
            VERY_LOW_BATTERY_START: "Muy baja inicio de la batería",
            VSWR: "VSWR",
            WATCHDOG_RESET: "Watchdog reset",
            WEEKLY_HISTORY_OVERFLOW_GAS_SMARTPOINT: "Historia semanal desbordamiento de gas Smartpoint",
            WEEKLY_MAGNETIC_GAS: "Gas magnética semanal",
            WEEKLY_REVERSE_FLOW_GAS: "Semanal inversa Flujo de Gas",
            WEIGHT_CHANGE_RATE_OVER_LIMIT: "Cambio de peso límite de velocidad Más",
            WEIGHT_CHANGE_RATE_UNDER_LIMIT: "Cambio de peso Límite Bajo Tasa",
            WEIGHT_INSIDE_RANGE: "Peso Dentro de la gama",
            WEIGHT_OUTSIDE_RANGE: "Peso fuera del rango",
            UNKNOWN: "Desconocida"
    },
    baseStationAlarmTypes: {
            AC_POWER_FAIL: "Fallo de alimentación de CA",
            DOOR_OPEN: "Puerta abierta",
            DOWNLINK_COMMANDS: "Comandos de enlace descendente",
            DUPLICATE_BUDDY_COUNT: "Amigos duplicados",
            ECU_FAULT: "Ambiental",
            FORWARD_POWER: "Poder delantero",
            FUSE_FAILURE: "Falla de fusible",
            GPS: "GPS Error",
            GPT: "GPT",
            IDLE_NOISE: "Ruido Inactivo",
            JT_MODULE: "JT Module",
            LAST_COUNTER_MESSAGE: "Último mensaje de contador",
            LAST_HEARD: "Último oído",
            LAST_HEARD_ON_AIR: "Último escuchado (en el aire)",
            LAST_TRANSMIT_REPORT: "Informe de última transmisión",
            BATTERY: "Batería baja",
            NTP: "NTP Error",
            NTP_DRIFTING: "La desviación de NTP excede la tolerancia permitida",
            NTP_MISSING: "NTP no responde",
            OVER_TEMPERATURE: "Exceso de temperatura",
            PPS: "PPS Error",
            RECTIFIER_POWER: "Rectificador de potencia",
            REFLECTED_POWER: "Poder reflejado",
            UNDER_TEMPERATURE: "Bajo temperatura",
            UNIQUE_BUDDY_COUNT: "Amigos únicos",
            UPLINK_MESSAGES: "Mensajes de enlace ascendente",
            UPLINK_TRAFFIC_DROP: "Caída del tráfico de enlace ascendente",
            VSWR: "VSWR"
    }
}
